import {
  GithubIcon,
  HubspotIcon,
  LinearIcon,
} from '@/assets/icons/brand-mark-icons';
import { Icons } from '@/assets/icons/icons';
import { LittlebirdMarkIcon } from '@/assets/icons/littlebird-mark';

import type {
  ActionCardPreviewType,
  ActionCardProviderId,
} from '@littlebird/action-cards';
import type { ComponentType } from 'react';

export type ActionCardIcon = ComponentType<{ className?: string }>;

// Shared kinds carry no icons (web SVGs cannot render in React Native), so
// each platform resolves them at render time from its own maps.
export const providerIcon: Record<ActionCardProviderId, ActionCardIcon> = {
  agents: Icons.users,
  'coding-agents': Icons.terminal,
  Littlebird: LittlebirdMarkIcon,
  gmail: Icons.gmail,
  outlook: Icons.outlook,
  'google-calendar': Icons.googleCalendar,
  'google-tasks': Icons.googleTasks,
  todoist: Icons.todoist,
  slack: Icons.slack,
  github: GithubIcon,
  linear: LinearIcon,
  hubspot: HubspotIcon,
  'microsoft-teams': Icons.microsoftTeams,
};

export const confirmationIcon: Partial<
  Record<ActionCardPreviewType, ActionCardIcon>
> = {
  gmail_email_draft: Icons.paperPlane,
  outlook_email_draft: Icons.paperPlane,
  slack_message: Icons.paperPlane,
  slack_message_with_attachments: Icons.paperPlane,
  slack_reaction: Icons.smile,
  microsoft_teams_message: Icons.paperPlane,
};
